import { DATA_API_SERVICE } from "@/appConfig";
import API from "@/api/api";

async function deepHealth() {
  const response = await API.get(`${DATA_API_SERVICE}/deep-health`);
  return response.status === 200;
}

async function getDiagnostics() {
  const response = await API.get(`${DATA_API_SERVICE}/diagnostic`);
  return response.data;
}

const APISystem = {
  deepHealth,
  getDiagnostics
};

export default APISystem;
